"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebGlGameObjectAtlas = void 0;
const BaseGameObjectAtlas_1 = require("./BaseGameObjectAtlas");
class WebGlGameObjectAtlas extends BaseGameObjectAtlas_1.BaseGameObjectAtlas {
    constructor(renderer) {
        super(2048, renderer);
    }
    removeTextureFromAtlas(id) {
        if (!(id in this.cachedTextureData)) {
            throw new Error(`Could not find id ${id}`);
        }
        const [x, y, w, h, atlasIndex] = this.cachedTextureData[id];
        delete this.cachedTextureData[id];
        this.renderer.bindRenderTexture(this.atlases[atlasIndex], null);
        const gl = this.renderer.gl;
        // turn on the scissor test.
        gl.enable(gl.SCISSOR_TEST);
        // set the scissor rectangle.
        gl.scissor(x, y, w, h);
        this.renderer.clear();
        // @ts-ignore
        this.renderer.bindRenderTexture();
    }
}
exports.WebGlGameObjectAtlas = WebGlGameObjectAtlas;
//# sourceMappingURL=module.js.map